import React, { useEffect, useState, useRef } from 'react';
interface SectionProps {
  children: React.ReactNode;
  className?: string;
  id?: string;
}
export function Section({
  children,
  className = '',
  id
}: SectionProps) {
  const ref = useRef<HTMLElement>(null);
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const observer = new IntersectionObserver(([entry]) => {
      if (entry.isIntersecting) {
        setIsVisible(true);
        observer.unobserve(el);
      }
    }, {
      rootMargin: '-80px'
    });
    observer.observe(el);
    return () => observer.disconnect();
  }, []);
  return <section ref={ref} id={id} className={`py-16 md:py-24 px-4 relative ${className}`} data-id="element-1">
      <div className={`max-w-3xl mx-auto transition-all duration-500 ease-out ${isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`} data-id="element-2">
        {children}
      </div>
    </section>;
}